import React, {useRef, useState, useEffect} from "react";
import Layout from "../../../Components/Layout";
import { Layout20,Layout80, LayoutContainer, Input, InputBarOffice, TextArea, CategoryContainer, Category, SectionH2, SectionH2BarOffice, InputFile, DoubleInput, DoubleInputBarOffice, InputLikeCategory, ProductsAlternativeContainer, ProductsAlternative, ProductsAlternativeSearch, ProductsAlternativeSearchInput, ProductsAlternativeSearchResults, ProductsAlternativeSearchResultItem, ProductsAlternativeAdded, ProductsAlternativeAddedPill } from "./productCreator/style";
import { H1 } from "./style";
import { HomeItemContainer, HomeItemImage, HomeItemInfo, HomeItemReference, HomeItemTitle, OfferItemAddToCartButton, OfferItemAddToCartContainer, OfferItemAddToCartSelect, OfferItemDiscount, OfferItemOldPrice, OfferItemPrice, OfferItemPriceContainer } from "../../Home/style";
import { BiSolidCart } from "react-icons/bi";
import { Spacer } from "@chakra-ui/react";
import Button from "../../../Components/Miscellaneous/Button";
import { LiaTimesCircleSolid } from "react-icons/lia";
import { BiPlus } from "react-icons/bi";
import AuthService from "../../../AuthService";
import { Portal } from "react-portal";
import Modal from "../../../Components/Miscellaneous/Modal";
import ProductService from "../../../Utils/API/products";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import CreatableSelect from 'react-select/creatable';
import axios from 'axios';
export default function ProductEdit() {

    const fileInput = useRef(null);
    const {id} = useParams();
    const [tags, setTags] = useState([]);
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [image, setImage] = useState(null);
    const [price, setPrice] = useState(0);
    const [stock, setStock] = useState(0);
    const [ean, setEan] = useState('');
    const [reference, setReference] = useState('');
    const [discounts, setDiscounts] = useState([]);
    const [q, setQ] = useState(1);
    const [priceDiscounts, setPriceDiscounts] = useState(null);
    const [quantityDiscounts, setQuantityDiscounts] = useState(null);
    const [searchItems, setSearchItems] = useState([]);
    const [categories, setCategories] = useState([]);
    const [search, setSearch] = useState('');
    const [alternativeProducts, setAlternativeProducts] = useState([]);
    const [aProductShow, setAProductShow] = useState(false);

    // ✅ NUEVO: Estados para campos específicos de BarOffice
    const [publicPrice, setPublicPrice] = useState(0);
    const [barOfficeDiscounts, setBarOfficeDiscounts] = useState([]);
    const [barOfficePriceDiscounts, setBarOfficePriceDiscounts] = useState(null);
    const [barOfficeQuantityDiscounts, setBarOfficeQuantityDiscounts] = useState(null);

    // ✅ NUEVO: Estados para proveedor
    const [supplier, setSupplier] = useState(null);
    const [supplierOptions, setSupplierOptions] = useState([]);
    /**
     * {
  "name": "",
  "description": "",
  "category": [],
  "productURL": "[category[0]]/name_slashed",
  "price": price,
  "discounted": false,
  "stock": stock,
  "store": "DistribucionesRB",
  "EAN": "EAN",
  "reference": "Reference",
  "tags": [],
  "quantityStep": quantityStep,
  "alternatives": [],
  "discounts": [],
}
     */

    const fetchProduct = async () => {
        fetch('https://api.rb.beeapp.es/admin/product/'+id, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        })
        .then(response => response.json())
        .then(data => {
            setCategories(data.category);
            setName(data.name);
            console.log(data.name);
            setDescription(data.description);
            setPrice(data.price);
            setStock(data.stock);
            setTags(data.tags);
            setEan(data.EAN);
            setReference(data.reference);
            setQ(data.quantityStep);
            setDiscounts(data.discounts || []);
            setAlternativeProducts(data.alternatives.map(item => item.productID) || []);
            setImage(data.images[0].replace('https://cdn.beeapp.es/', ''));

            // ✅ NUEVO: Cargar datos específicos de BarOffice
            setPublicPrice(parseFloat(data.publicPrice) || 0);
            setBarOfficeDiscounts(data.barOfficeDiscounts || []);

            // ✅ NUEVO: Cargar proveedor
            if (data.supplier && data.supplier.trim() !== '') {
                setSupplier({ value: data.supplier, label: data.supplier });
            }
        })
        .catch(error => {
            console.error(error);
        })
    }

    useEffect(() => {
        fetchProduct();
        fetchSuppliers();
    }, []);

    // ✅ NUEVO: Cargar proveedores existentes
    const fetchSuppliers = async () => {
        try {
            const response = await axios.get('https://api.rb.beeapp.es/admin/products?page=1&limit=5000', {
                headers: { 'Authorization': 'Bearer ' + AuthService.getToken() }
            });

            // Extraer proveedores únicos
            const suppliers = [...new Set(
                response.data.results
                    .map(p => p.supplier)
                    .filter(s => s && s.trim() !== '')
            )].sort();

            setSupplierOptions(suppliers.map(s => ({ value: s, label: s })));
        } catch (error) {
            console.error('Error loading suppliers:', error);
        }
    };

    function makeSearch(search){
        ProductService.searchProducts(search).then(res => {
            //change objectID to _id
            res = res.map((item) => {
                return {
                    ...item,
                    productID: item.objectID,
                    
                    _id: item.objectID
                }
            });
            //delete objectID
            res = res.map((item) => {
                delete item.objectID;
                return item;
            });
            //delete _highlightResult
            res = res.map((item) => {
                delete item._highlightResult;
                return item;
            });

            setSearchItems(res);

            console.log(searchItems);
        }
        ).catch(err => {
            console.log(err);
        });
    }

    const createProduct = () => {
        // ✅ CORREGIDO: Convertir todos los campos numéricos correctamente
        const product = {
            name,
            description,
            category: categories,
            images: ["https://cdn.beeapp.es/"+image],
            productURL: `${categories[0]}/${name.replaceAll(' ', '-').replaceAll('/','').toLowerCase()}`,
            price: parseFloat(price) || 0, // ✅ Convertir precio a número
            discounted: false,
            stock: parseInt(stock) || 0, // ✅ Convertir stock a número entero
            store: 'DistribucionesRB',
            EAN: ean,
            reference: reference,
            tags,
            quantityStep: parseInt(q) || 1, // ✅ Convertir quantityStep a número entero
            alternatives: alternativeProducts.length >= 1 ? alternativeProducts.map((item) => {
                return item?.productID;
            }) : [],
            discounts: discounts.map(discount => ({
                ...discount,
                discountedPrice: parseFloat(discount.discountedPrice) || 0, // ✅ Convertir precios de descuento
                minQuantity: parseInt(discount.minQuantity) || 1 // ✅ Convertir cantidades mínimas
            })),
            // ✅ NUEVO: Campos específicos para BarOffice
            publicPrice: parseFloat(publicPrice) || 0,
            barOfficeDiscounts: barOfficeDiscounts.map(discount => ({
                ...discount,
                discountedPrice: parseFloat(discount.discountedPrice) || 0,
                minQuantity: parseInt(discount.minQuantity) || 1
            })) || [],
            // ✅ NUEVO: Campo de proveedor
            supplier: supplier ? supplier.value : ''
        }

        fetch('https://api.rb.beeapp.es/products/'+id, {
            method: 'PATCH',
            headers: {
                'Authorization': 'Bearer ' + AuthService.getToken(),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(product)
        })
        .then(response => response.json())
        .then(data => {
            console.log(data);
            toast.success('Producto actualizado correctamente');
        })
        .catch(error => {
            console.error(error);
        })

    }


    const handleFileInput = (e) => {
        const file = e.target.files[0];

        //upload file to /admin/imageUpload

        const formData = new FormData();
        formData.append('image', file);

        fetch('https://api.rb.beeapp.es/admin/imageUpload', {
            method: 'POST',
            headers: {
                Authorization: 'Bearer ' + AuthService.getToken()
            },
            body: formData
        })
        .then(response => response.json())
        .then(data => {
            setImage(data.imagename);
        })
        .catch(error => {
            console.error(error);
        })


    }


    const spanishPrepositions = new Set([
        'a', 'ante', 'bajo', 'con', 'contra', 'de', 'desde', 'durante', 'en',
        'entre', 'hacia', 'hasta', 'mediante', 'para', 'por', 'según', 'sin',
        'sobre', 'tras', 'aunque', 'como', 'cuando', 'donde', 'mientras',
        'porque', 'si', 'siempre', 'también', 'todavía', 'ya'
      ]);

      const spanishDeterminers = new Set([
        'este', 'esta', 'esto', 'estos', 'estas',
        'ese', 'esa', 'eso', 'eses', 'esas',
        'aquel', 'aquella', 'aquello', 'aquellos', 'aquellas',
        'el', 'la', 'los', 'las',
        'un', 'una', 'unos', 'unas'
      ]);

    function addTag(e){
        if(e.key === 'Enter'){
            setTags([...tags, e.target.value]);
            e.target.value = '';
        }
    }

    const deleteProduct = (id) => {

        const confirm = window.confirm('¿Estás seguro de que quieres eliminar este producto?');
        if(!confirm) return;

        fetch('https://api.rb.beeapp.es/products/'+id, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + AuthService.getToken()
            }
        })
        .then(response => response.json())
        .then(data => {
            console.log(data);
            toast.success('Producto eliminado correctamente');
        })
        .catch(error => {
            console.error(error);
        })
    }

    function addDiscount(){
        /**
         *     {
      minQuantity: {
        type: Number,
        required: true,
        min: 1,
      },
      discountedPrice: {
        type: Number,
        required: true,
      },
    },
         */

        // ✅ CORREGIDO: Convertir valores a números al añadir descuentos
        if(priceDiscounts === null || quantityDiscounts === null) return;

        setDiscounts([...discounts, {
            minQuantity: parseInt(quantityDiscounts) || 1,
            discountedPrice: parseFloat(priceDiscounts) || 0
        }]);

        // ✅ MEJORADO: Limpiar campos después de añadir
        setPriceDiscounts('');
        setQuantityDiscounts('');
    }

    // ✅ NUEVO: Función para agregar descuentos de BarOffice
    function addBarOfficeDiscount(){
        if(barOfficePriceDiscounts === null || barOfficeQuantityDiscounts === null) return;

        setBarOfficeDiscounts([...barOfficeDiscounts, {
            minQuantity: parseInt(barOfficeQuantityDiscounts) || 1, // ✅ Convertir a número
            discountedPrice: parseFloat(barOfficePriceDiscounts) || 0 // ✅ Convertir a número
        }]);

        setBarOfficePriceDiscounts(''); // ✅ Limpiar con string vacío
        setBarOfficeQuantityDiscounts(''); // ✅ Limpiar con string vacío
    }

    function setNameValue(e){
        setName(e.target.value);
        //split by space and add to tags

        //if the word is a preposition, the word before and after are united with dash


        const splitted = e.target.value.split(' ');


        //eliminate determiners
        splitted.filter((item) => {
            return !spanishDeterminers.has(item);
        }
        );

        splitted.map((item, index) => {
            if(spanishPrepositions.has(item)){
                //create a new string with the previous and next word and the preposition with a dash
                //in case the next word is the last one, the dash is not added

                if(index === splitted.length - 1){
                    splitted[index - 1] = splitted[index - 1] + '-' + item;
                    //remove the preposition
                    splitted.splice(index, 1);
                    return;
                }

                splitted[index - 1] = splitted[index - 1] + '-' + item + '-' + splitted[index + 1];
                //remove the next word
                splitted.splice(index + 1, 1);
                //remove the preposition
                splitted.splice(index, 1);

            }
        }
        );

        //filter empty strings
        splitted.filter((item) => {
            return item !== '';
        });

        //filter tags that are already in the array
        splitted.filter((item) => {
            return !tags.includes(item);
        });

        //only remove the tags of name
        splitted.filter((item) => {
            return !name.includes(item);
        });


        setTags([...splitted]);

    }

    return (
        <LayoutContainer>
            <Layout80>
            <H1>Actualizar Producto</H1>
            <Input
                placeholder='Nombre'
                onChange={setNameValue}
                value={name}
                />
            <TextArea placeholder="Descripción"
                value={description}
            onChange={(e) => setDescription(e.target.value)}
            ></TextArea>
            <SectionH2>Categoría</SectionH2>
            <CategoryContainer>
            <Category
                onClick={() => {
                    if(categories.includes('ofertas')){
                        setCategories(categories.filter((item) => {
                            return item !== 'ofertas';
                        }));
                }
                else{
                    setCategories([...categories, 'ofertas']);
                }
            }
                }
                selected={categories.includes('ofertas')}
                >
                    Ofertas
                </Category>
                <Category
                onClick={() => {
                    if(categories.includes('escritura-y-correccion')){
                        setCategories(categories.filter((item) => {
                            return item !== 'escritura-y-correccion';
                        }));
                }
                else{
                    setCategories([...categories, 'escritura-y-correccion']);
                }
            }
                }
                selected={categories.includes('escritura-y-correccion')}
                >
                    Escritura y Corrección
                </Category>
                <Category
                onClick={() => {
                    if(categories.includes('productos-de-oficina')){
                        setCategories(categories.filter((item) => {
                            return item !== 'productos-de-oficina';
                        }));
                }
                else{
                    setCategories([...categories, 'productos-de-oficina']);
                }
            }
                }
                selected={categories.includes('productos-de-oficina')}
                >
                    Productos de Oficina
                </Category>
                <Category
                onClick={() => {
                    if(categories.includes('productos-escolares')){
                        setCategories(categories.filter((item) => {
                            return item !== 'productos-escolares';
                        }));
                }
                else{
                    setCategories([...categories, 'productos-escolares']);
                }
            }
                }
                selected={categories.includes('productos-escolares')}
                >
                    Productos Escolares
                </Category>
                <Category
                onClick={() => {
                    if(categories.includes('etiquetas-y-embalajes')){
                        setCategories(categories.filter((item) => {
                            return item !== 'etiquetas-y-embalajes';
                        }));
                }
                else{
                    setCategories([...categories, 'etiquetas-y-embalajes']);
                }
            }
        }
            selected={categories.includes('etiquetas-y-embalajes')}
                >
                Etiquetas y Embalajes
                </Category>
                <Category
                onClick={() => {
                    if(categories.includes('papel-cuadernos-y-sobres')){
                        setCategories(categories.filter((item) => {
                            return item !== 'papel-cuadernos-y-sobres';
                        }));
                }
                else{
                    setCategories([...categories, 'papel-cuadernos-y-sobres']);
                }
            }
        }
            selected={categories.includes('papel-cuadernos-y-sobres')}
                >
                Papel, Cuadernos y Sobres
                </Category>
                <Category
                onClick={() => {
                    if(categories.includes('archivo-y-clasificacion')){
                        setCategories(categories.filter((item) => {
                            return item !== 'archivo-y-clasificacion';
                        }));
                }
                else{
                    setCategories([...categories, 'archivo-y-clasificacion']);
                }
            }
        }
            selected={categories.includes('archivo-y-clasificacion')}
                >
                Archivo y Clasificacion
                </Category>
                <Category
                onClick={() => {
                    if(categories.includes('consumibles-y-accesorios-informaticos')){
                        setCategories(categories.filter((item) => {
                            return item !== 'consumibles-y-accesorios-informaticos';
                        }));
                }
                else{
                    setCategories([...categories, 'consumibles-y-accesorios-informaticos']);
                }
            }
        }
            selected={categories.includes('consumibles-y-accesorios-informaticos')}
                >
                Consumibles y Accesorios Informaticos
                </Category>
                <Category
                onClick={() => {
                    if(categories.includes('mobiliario-de-oficina')){
                        setCategories(categories.filter((item) => {
                            return item !== 'mobiliario-de-oficina';
                        }));
                }
                else{
                    setCategories([...categories, 'mobiliario-de-oficina']);
                }
            }
        }
            selected={categories.includes('mobiliario-de-oficina')}
                >
                Mobiliario de Oficina
                </Category>
                <Category
                onClick={() => {
                    if(categories.includes('organizacion')){
                        setCategories(categories.filter((item) => {
                            return item !== 'organizacion';
                        }));
                }
                else{
                    setCategories([...categories, 'organizacion']);
                }
            }
        }
                selected={categories.includes('organizacion')}
                >
                Organizacion
                </Category>
                <Category
                onClick={() => {
                    if(categories.includes('juegos')){
                        setCategories(categories.filter((item) => {
                            return item !== 'juegos';
                        }));
                }
                else{
                    setCategories([...categories, 'juegos']);
                }
            }
        }
            selected={categories.includes('juegos')}
                >
                Juegos
                </Category>
            </CategoryContainer>
            <SectionH2>Imagen</SectionH2>
            <InputFile type="file" ref={fileInput}
            onChange={(e) => handleFileInput(e)}

>

            </InputFile>
            <label htmlFor="file" 
                onClick={() => {
                    fileInput.current.click();
                }
                }
            >Seleccionar archivo</label>
            <DoubleInput>
                <Input placeholder="Precio" type="number"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                ></Input>
                <Input placeholder="Stock" type="number"
                value={stock}
                onChange={(e) => setStock(e.target.value)}
                ></Input>
            </DoubleInput>
            
            {/* ✅ NUEVO: Sección específica para BarOffice */}
            <SectionH2BarOffice>BarOffice - Precio Público</SectionH2BarOffice>
            <InputBarOffice 
                placeholder="Precio Público BarOffice (€)" 
                type="number"
                step="0.01"
                value={publicPrice}
                onChange={(e) => setPublicPrice(parseFloat(e.target.value) || 0)}
            />
            <SectionH2>Tags</SectionH2>
            <CategoryContainer>
                <InputLikeCategory placeholder="Tag"
                onKeyUp={addTag}
                ></InputLikeCategory>
                {
                    tags.map((tag, index) => {
                        return <Category key={index}>{tag}
                        <button style={{
                            border: 'none',
                            background: 'none',
                            marginLeft: 'auto',
                            cursor: 'pointer',
                            outline: 'none',
                            color: 'currentColor'
                        }}  
                        onClick={() => {
                            setTags(tags.filter((item) => {
                                return item !== tag;
                            }));
                        }}
                        >
                            <LiaTimesCircleSolid size={16}/>
                        </button>
                        </Category>
                    })
                }
            </CategoryContainer>
            <DoubleInput>
                <Input placeholder="EAN" type="text"
                value={ean}
                onChange={(e) => setEan(e.target.value)}
                ></Input>
                <Input placeholder="Referencia" type="text"
                value={reference}
                onChange={(e) => setReference(e.target.value)}
                ></Input>
                <Input placeholder="Cantidad Mínima" type="number"
                value={q}
                onChange={(e) => setQ(e.target.value)}
                ></Input>
            </DoubleInput>

            <SectionH2>Proveedor</SectionH2>
            <CreatableSelect
                isClearable
                options={supplierOptions}
                value={supplier}
                onChange={setSupplier}
                placeholder="Seleccionar o crear proveedor..."
                formatCreateLabel={(inputValue) => `Crear proveedor: "${inputValue}"`}
                styles={{
                    control: (base) => ({
                        ...base,
                        border: '1px solid #e5e7eb',
                        borderRadius: '8px',
                        padding: '4px',
                        fontSize: '14px'
                    })
                }}
            />

            <SectionH2>Descuentos</SectionH2>
                {
                    discounts.length === 0 ? (
                        null
                    ) : (
                        
                        discounts.map((discount, index) => {
                            return (
                                <DoubleInput key={index}>
                                    <Input placeholder="Precio" type="number"
                                    value={discount.discountedPrice}
                                    onChange={(e) => {
                                        setDiscounts(discounts.map((item, i) => {
                                            if(i === index){
                                                return {
                                                    ...item,
                                                    discountedPrice: e.target.value
                                                }
                                            }
                                            return item;
                                        }));
                                    }}
                                    ></Input>
                                    <Input placeholder="Cantidad" type="number"
                                    value={discount.minQuantity}
                                    onChange={(e) => {
                                        setDiscounts(discounts.map((item, i) => {
                                            if(i === index){
                                                return {
                                                    ...item,
                                                    minQuantity: e.target.value
                                                }
                                            }
                                            return item;
                                        }));
                                    }}
                                    ></Input>
                                    <Button primary
                                        customStyle={{
                                            height: 'auto',
                                            width: '50px !important'
                                        }}
                                        onClick={() => {
                                            setDiscounts(discounts.filter((item, i) => {
                                                return i !== index;
                                            }));
                                        }}
                                    >
                                        <LiaTimesCircleSolid size={24}/>
                                    </Button>
                                </DoubleInput>
                            )
                        }
                        )
                        
                    )
                }
                                        <DoubleInput>
                        <Input placeholder="Precio" type="number"
                        value={priceDiscounts}
                        onChange={(e) => {
                            setPriceDiscounts(e.target.value);
                        }
                        }
                        />
                        <Input placeholder="Cantidad" type="number"
                            value={quantityDiscounts}
                            onChange={(e) => {
                                setQuantityDiscounts(e.target.value);
                            }
                            }
                        />
                        <Button primary
                            customStyle={{
                                height: 'auto',
                                width: '50px !important'
                            }}
                            onClick={addDiscount}
                        >
                            <BiPlus size={24}/>
                        </Button>
                    </DoubleInput>

            {/* ✅ NUEVO: Sección de descuentos específicos para BarOffice */}
            <SectionH2BarOffice>BarOffice - Descuentos por Volumen</SectionH2BarOffice>
            {
                barOfficeDiscounts.length === 0 ? (
                    null
                ) : (
                    barOfficeDiscounts.map((discount, index) => {
                        return (
                            <DoubleInputBarOffice key={index}>
                                <InputBarOffice placeholder="Precio Descuento" type="number"
                                step="0.01"
                                value={discount.discountedPrice}
                                onChange={(e) => {
                                    setBarOfficeDiscounts(barOfficeDiscounts.map((item, i) => {
                                        if(i === index){
                                            return {
                                                ...item,
                                                discountedPrice: parseFloat(e.target.value) || 0
                                            }
                                        }
                                        return item;
                                    }));
                                }}
                                ></InputBarOffice>
                                <InputBarOffice placeholder="Cantidad Mínima" type="number"
                                step="1"
                                value={discount.minQuantity}
                                onChange={(e) => {
                                    setBarOfficeDiscounts(barOfficeDiscounts.map((item, i) => {
                                        if(i === index){
                                            return {
                                                ...item,
                                                minQuantity: parseInt(e.target.value) || 1
                                            }
                                        }
                                        return item;
                                    }));
                                }}
                                ></InputBarOffice>
                                <Button primary
                                    customStyle={{
                                        height: 'auto',
                                        width: '50px !important',
                                        backgroundColor: '#1976d2',
                                        borderColor: '#1976d2'
                                    }}
                                    onClick={() => {
                                        setBarOfficeDiscounts(barOfficeDiscounts.filter((item, i) => {
                                            return i !== index;
                                        }));
                                    }}
                                >
                                    <LiaTimesCircleSolid size={24}/>
                                </Button>
                            </DoubleInputBarOffice>
                        )
                    })
                )
            }
            <DoubleInputBarOffice>
                <InputBarOffice placeholder="Precio Descuento" type="number"
                step="0.01"
                value={barOfficePriceDiscounts}
                onChange={(e) => {
                    setBarOfficePriceDiscounts(parseFloat(e.target.value) || 0);
                }}
                />
                <InputBarOffice placeholder="Cantidad Mínima" type="number"
                    step="1"
                    value={barOfficeQuantityDiscounts}
                    onChange={(e) => {
                        setBarOfficeQuantityDiscounts(parseInt(e.target.value) || 1);
                    }}
                />
                <Button primary
                    customStyle={{
                        height: 'auto',
                        width: '50px !important',
                        backgroundColor: '#1976d2',
                        borderColor: '#1976d2'
                    }}
                    onClick={addBarOfficeDiscount}
                >
                    <BiPlus size={24}/>
                </Button>
            </DoubleInputBarOffice>

                    <Button primary onClick={() => {
                        setAProductShow(true);
                    }
                    }>Añadir productos relacionados</Button>
            <Spacer h="20px"/>
            </Layout80>
            <Layout20>
            <HomeItemContainer>
                <HomeItemImage
                    src={image === null ? "https://marlu.tpvlinker.com/thumbs/img/products/9/3/2/932_home_default.jpg" : `https://cdn.beeapp.es/${image}`}
                >
                </HomeItemImage>
                <HomeItemInfo>
                    <HomeItemTitle>{name}</HomeItemTitle>
                    <HomeItemReference> Ref. {reference}</HomeItemReference>
                    <OfferItemPriceContainer>
                        <OfferItemDiscount>
                           {price} €
                        </OfferItemDiscount>
                    </OfferItemPriceContainer>

                    <OfferItemAddToCartContainer>
                        <OfferItemAddToCartButton>
                            <BiSolidCart size={24}/>
                            Añadir
                        </OfferItemAddToCartButton>
                        <OfferItemAddToCartSelect>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            </OfferItemAddToCartSelect>
                    </OfferItemAddToCartContainer>
                </HomeItemInfo>
            </HomeItemContainer>
            <Button primary
                customStyle={{
                    marginTop: 'auto'
                }}
                disabled={name === '' || ean === '' || reference === ''}
                onClick={() => createProduct()}
            >Actualizar</Button>
            <Button outline onClick={() => deleteProduct(id)}>Eliminar</Button>
            </Layout20>
            {
                aProductShow && (
                    <ProductsAlternativeContainer>
                        <ProductsAlternative>
                            <ProductsAlternativeSearch>
                                <ProductsAlternativeSearchInput placeholder="Buscar producto"
                                onChange={(e) => {
                                    setSearch(e.target.value);
                                    makeSearch(e.target.value);
                                }
                                }
                                ></ProductsAlternativeSearchInput>

                            </ProductsAlternativeSearch>
                            <ProductsAlternativeAdded>
                                    {
                                        alternativeProducts.map((item, index) => {
                                            return (
                                                <ProductsAlternativeAddedPill key={index}
                                                    onClick={() => {
                                                        setAlternativeProducts(alternativeProducts.filter((item, i) => {
                                                            return i !== index;
                                                        }));
                                                    }
                                                    }
                                                >
                                                    {item.name}
                                                </ProductsAlternativeAddedPill>
                                            )
                                        }
                                        )
                                    }
                                </ProductsAlternativeAdded>
                            <ProductsAlternativeSearchResults>
                                {
                                  searchItems.map((item, index) => {
                                    console.log(item);
                                        return (
                                            <ProductsAlternativeSearchResultItem key={index}
                                            onClick={() => {
                                                if(alternativeProducts.includes(item)) return;
                                                setAlternativeProducts([...alternativeProducts, {
                                                    productID: item._id,
                                                    name: item.name
                                                }]);
                                                console.log(alternativeProducts);
                                            }
                                            }
                                            >
                                                {item.name}
                                            </ProductsAlternativeSearchResultItem>
                                        )
                                    }
                                    )
                                }

                            </ProductsAlternativeSearchResults>
                        <Button outline onClick={() => setAProductShow(false)}>Cerrar</Button>
                        </ProductsAlternative>
                    </ProductsAlternativeContainer>
                )
            }

        </LayoutContainer>


    )
}

